/**
 * Omits the given key (property name) from an object, and returns
 * the new object
 */
export function omit(obj: Record<string, any>, keys: string | string[]) {
    if (!Array.isArray(keys)) {
        keys = [keys]
    }
    return Object.fromEntries(
        Object.entries(obj).filter(([k]) => !keys.includes(k))
    )
}

/**
 * Based on lodash.pick() but implemented using more modern native methods

    const obj = { 'a': 1, 'b': '2', 'c': 3 };
    pick(obj, ['a', 'c'])
    // result: { 'a': 1, 'c': 3 }
 */
export function pick<TObject extends Record<string, any>>(
    obj: TObject,
    keys: string | string[]
): Partial<TObject> {
    if (!Array.isArray(keys)) {
        keys = [keys]
    }
    return Object.fromEntries(
        Object.entries(obj).filter(([key]) => keys.includes(key))
    ) as any
}
